import { inject, Injectable } from '@angular/core';

import { ProductSearchPage } from '@spartacus/core';
import { ProductListComponentService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { DpRelatedParts } from '@app/core/types/view/dp-products-details.interface';
import { ProductsCategory } from '@app/core/types/view/products-category.type';
import { PRODUCT_LIST_PAGE_SIZE } from '@app-modules/product/product-list/constants';
import { ProductListStateType } from '@app-modules/product/product-list/types';

@Injectable({ providedIn: 'root' })
export class DpProductListService {
  #categoryMap = new Map<string, ProductsCategory>();
  readonly #productListComponentService = inject(ProductListComponentService);

  get model$(): Observable<ProductListStateType> {
    return this.#productListComponentService.model$.pipe(
      tap((model) => {
        if (model.pagination?.currentPage === 0) {
          this.#categoryMap = new Map<string, ProductsCategory>();
        }
      }),
      map((model: ProductSearchPage) => this.mapModelData(model))
    );
  }

  private mapModelData(model: ProductSearchPage): ProductListStateType {
    const { relatedParts = [], pagination, sorts = [], freeTextSearch } = model;
    this.#groupProductsByCategories(relatedParts);
    const categories = Array.from(this.#categoryMap.values());
    const isLastPage = Number(pagination?.totalPages ?? 0) === Number(pagination?.currentPage ?? 0) + 1;
    return {
      categories,
      sorts,
      pageSize: pagination?.pageSize ?? PRODUCT_LIST_PAGE_SIZE[0],
      currentPage: pagination?.currentPage ?? 0,
      freeTextSearch,
      counter: {
        total: pagination?.totalResults ?? 0,
        shown: isLastPage
          ? (pagination?.totalResults ?? 0)
          : (Number(pagination?.currentPage ?? 0) + 1) * Number(pagination?.pageSize ?? 0)
      }
    };
  }

  #groupProductsByCategories(relatedParts: DpRelatedParts[]): void {
    relatedParts.forEach(({ categories }) => {
      categories.forEach((category) => {
        if (category.code && !this.#categoryMap.has(category.code)) {
          this.#categoryMap.set(category.code, { ...category });
        }
      });
    });
  }
}
